export default __webpack_public_path__ + "static/media/chat.2945aca2.png";